import React, { ReactNode, useRef } from 'react';
import { InputGroup, InputGroupProps } from '@companydotcom/potion';
import { UseFormRegisterReturn } from 'react-hook-form';

interface FileUploadProps extends InputGroupProps {
  register: UseFormRegisterReturn;
  accept?: string;
  multiple?: boolean;
  children?: ReactNode;
}

export const FileUpload = (props: FileUploadProps) => {
  const { register, accept, multiple, children, ...restProps } = props;
  const inputRef = useRef<HTMLInputElement | null>(null);
  const { ref, ...rest } = register as { ref: (instance: HTMLInputElement | null) => void };

  const handleClick = () => inputRef.current?.click();

  return (
    // @ts-ignore
    <InputGroup onClick={handleClick} {...restProps}>
      <input
        type="file"
        multiple={multiple || false}
        hidden
        accept={accept}
        {...rest}
        ref={e => {
          ref(e);
          inputRef.current = e;
        }}
      />
      <>{children}</>
    </InputGroup>
  );
};
